import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import messengerApiService from '@widgets/messenger/services/messengerApiService'
import { useWidgetAttachments, type UploadApiCallback } from '@widgets/messenger/compositions/useWidgetAttachments'
import { useEmailAttachmentStore } from '@widgets/messenger/stores/useEmailAttachmentStore'

export const useWidgetEmailAttachments = () => {
  const widgetStore = useWidgetStore()
  const attachmentStore = useEmailAttachmentStore()
  const widgetAttachments = useWidgetAttachments(attachmentStore, 'email')

  const uploadApiCallback: UploadApiCallback = ({ file, id }) => {
    return messengerApiService.uploadEmailAttachment(
      widgetStore.uniqueCode.value,
      {
        file,
      },
      (event) => {
        widgetAttachments.updateProgress(id, event.loaded)
      },
    )
  }

  const uploadAttachments = (files: File[]) => {
    return widgetAttachments.uploadAttachments({
      files,
      uploadApiCallback,
    })
  }

  const retryAttachment = (id: string) => {
    return widgetAttachments.retryAttachment({ id, uploadApiCallback })
  }

  return {
    attachments: widgetAttachments.attachments,
    uploadAttachments,
    retryAttachment,
    removeAttachment: widgetAttachments.removeAttachment,
    setAttachments: widgetAttachments.setAttachments,
    clearAttachments: widgetAttachments.clearAttachments,
    getUploadedAttachments: widgetAttachments.getUploadedAttachments,
  }
}
